import { Stack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import Artists from '~/components/ui/Artists';
import Playlists from '~/components/ui/Playlists';
import Titles from '~/components/ui/Titles';

function SearchResult() {
  const { t } = useTranslation('common');

  return (
    <Stack spacing={10}>
      <Titles />
      <Artists />
      <Playlists title={t('playlists')} linkText={t('actions.allPlaylists')} />
    </Stack>
  );
}

export default SearchResult;
